export default __webpack_public_path__ + "static/media/no_img_innovation.ab7ed739.png";